var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=ArrowLeft, colour=NeutralSubdued, htmlTag=img, assetKey=Content, state=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_back",
    d: "M8.65453 13L14.2545 18.6L12.8295 20L4.82953 12L12.8295 4L14.2545 5.4L8.65453 11H20.8295V13H8.65453Z",
    fill: "#707B8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.4ba065c9fb48d990d96a39e502220669.svg";
export { ForwardRef as ReactComponent };